import constants from "../../constants";
import utils from "../utils";

export const vbAttachmentTdhvpService = {
  downloadVbOutgoingDoc(userDeptRoleId, docId) {
    this.downloadFile(constants.DOWNLOAD_FILE_URL.DOWNLOAD_TDHVP_OUTGOING_DOC, {
      userDeptRoleId,
      docId
    });
  },

  downloadVbIncomingDoc(userDeptRoleId, docId) {
    this.downloadFile(constants.DOWNLOAD_FILE_URL.DOWNLOAD_TDHVP_INCOMING_DOC, {
      userDeptRoleId,
      docId
    });
  },

  downloadFile(url, options) {
    // console.log(
    //   this.buildAttachmentURL(utils.merge({ downloadFileURL: url }, options))
    // );
    window.open(
      this.buildAttachmentURL(utils.merge({ downloadFileURL: url }, options)),
      "_blank"
    );
  },

  buildAttachmentURL(options) {
    let params = [];
    let downloadFileURL = options.downloadFileURL;
    if (options)
      for (let key in options)
        params.push(`${key}=${encodeURIComponent(options[key])}`);
    return `${constants.BASE_SERVICE_URL}${downloadFileURL}?${params.join(
      "&"
    )}`;
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbAttachmentTdhvpService.js